export const SYSTEM_OF_MEASURES = {
  SI: 'si',
  SI_CL: 'si_cl',
  IMPERIAL: 'imperial',
};

export const UNIT_TYPES = {
  BODY_WEIGHT: {
    SI: 'kg',
    SI_CL: 'kg',
    IMPERIAL: 'lb',
  },
  LENGTH_BODY_MEASUREMENT: {
    SI: 'cm',
    SI_CL: 'cm',
    IMPERIAL: 'in',
  },
  VOLUME: {
    SI: 'ml',
    SI_CL: 'cl',
    IMPERIAL: 'oz',
  },
};
